import * as React from 'react'
import FlagIconFactory from 'react-flag-icon-css'

const FlagIcon = FlagIconFactory(React, { useCssModules: false }) ;

export default FlagIcon
